import React from 'react';
import './user info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, TreeSelect, Image, Spin, Empty } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';
import { Info } from '@material-ui/icons';
import Skeleton from 'react-loading-skeleton';
import PaginationButtons from '../../component/pagenation/pagenation';

const { TreeNode } = TreeSelect;
class UserInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    id: this.props.location.state.data.id,
    user: this.props.location.state ? this.props.location.state.data : [],
    fullname: this.props.location.state.data.fullname,
    email: this.props.location.state.data.email,
    type: this.props.location.state.data.type,
    oldType: this.props.location.state.data.type,
    phone: this.props.location.state.data.phone,
    accountType: this.props.location.state.data.accountType,
    isVerified: this.props.location.state.data.isVerified,
    enableAsMarketer: false,
    modal: false,
    reason: "",
    adsCount: 0,
    requestsCount: 0,
    contactRequestCount: 0,
    totalCommission: 0,
    clientsCount: 0,
    approved: false,
    img: this.props.location.state ? this.props.location.state.data.img !== "" ? this.props.location.state.data.img : null : null,
    country: this.props.location.state.data.country ? this.props.location.state.data.country.id : 1,
    countryCode: '',
    city: this.props.location.state.data.city ? this.props.location.state.data.city.id : null,
    commercialFile: null,
    fileType: "data",
    filePreviewName: [],
    countries: [],
    cities: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    imgType: 'url',
    money: 0,
    agencyType: '',
    imgName: '',
    requests: [],
    notApprovedReason: "",
    modal2: false,
    permissions: [],
    permission: null,
    modal3: false,
    licenseNumber: '',
    idNumber: '',
    isVerifiedIdNumber: false,
    brokerLicenseNumber: '',
    bio: '',
    workingProjects: [],
    managingProjects: [],
    workingCity: [],
    projects: []
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    this.getUserData()
    this.getRequests()
    this.getCities(this.props.location.state.data.country ? this.props.location.state.data.country.id : 0)
    this.fileChangedHandler = this.fileChangedHandler.bind(this);
    if (this.state.type === "SUB-ADMIN") {
      this.getPermissions()
      this.getProjects()
    }
    this.getCountries()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getUserData = () => {
    axios.get(`${BASE_END_POINT}${this.state.id}/getUser`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log('theUser  ', response.data)
        this.setState({
          permission: response.data.user.permission ? response.data.user.permission.id : [],
          adsCount: response.data.user.adsCount,
          accountType: response.data.user.accountType,
          loading: false,
          approved: response.data.user.approved,
          isVerified: response.data.user.isVerified,
          phone: response.data.user.phone ? response.data.user.phone : "",
          email: response.data.user.email ? response.data.user.email : "",
          city: response.data.user.city ? response.data.user.city.id : [],
          requestsCount: response.data.user.requestsCount,
          contactRequestCount: response.data.user.contactRequestCount,
          totalCommission: response.data.user.totalCommission ? response.data.user.totalCommission : 0,
          clientsCount: response.data.user.clientsCount ? response.data.user.clientsCount : 0,
          agencyType: response.data.user.agencyType,
          licenseNumber: response.data.user.licenseNumber,
          idNumber: response.data.user.idNumber,
          isVerifiedIdNumber: response.data.user.isVerifiedIdNumber,
          brokerLicenseNumber: response.data.user.brokerLicenseNumber,
          bio: response.data.user.bio,
          workingProjects: response.data.user.workingProjects,
          managingProjects: response.data.user.managingProjects,
          workingCity: response.data.user.workingCity,
          enableAsMarketer: response.data.user.enableAsMarketer,
          commercialFile: response.data.user.commercialFile ? response.data.user.commercialFile.length > 0 ? response.data.user.commercialFile : null : null,
        })
        this.getCountry(response.data.user.country ? response.data.user.country.id : 1)
      })
      .catch(error => {
        console.log('user ERROR  ', error)
        console.log('user ERROR  ', error.respose)
      })
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getPermissions = () => {
    axios.get(`${BASE_END_POINT}permission/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ permissions: response.data.data, loading: false })
      })
      .catch(error => {
        console.log("ALL permissions ERROR")
        console.log(error.response)
      })
  }
  getRequests = (page) => {
    axios.get(`${BASE_END_POINT}requests?page=1&user=${this.state.id}`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log(response.data.data)
        this.setState({
          requests: response.data.data,
          page: response.data.page,
          pages: response.data.pageCount
        })
      })
      .catch(error => {
        console.log("ALL ads ERROR")
        console.log(error.response)
      })
  }
  getCountry = (id) => {
    axios.get(`${BASE_END_POINT}countries/${id}`)
      .then(response => {
        console.log("country", response.data.data)
        console.log("phone", this.state.phone.replace(response.data.data.countryCode, ""))
        this.setState({
          countryCode: response.data.data.countryCode,
          phone: this.state.phone.replace(response.data.data.countryCode, "")
        })
      })
      .catch(error => {
        console.log(" country ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    console.log(country)
    axios.get(`${BASE_END_POINT}countries/1/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log('cities  ', response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log('cities ERROR  ', error)
        console.log('cities ERROR  ', error.respose)
      })
  }
  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ countries: response.data.data })
      })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  update = () => {
    const { img, city, fullname, phone, email, password, country, countryCode, permission, type, oldType, agencyType, commercialFile, fileType, bio,
      licenseNumber, brokerLicenseNumber, idNumber, workingProjects, managingProjects, workingCity } = this.state
    let l = message.loading('Wait..', 2.5)

    if (hasValue(fullname) && hasValue(phone)) {

      console.log(countryCode)
      console.log("password", password)
      let data = new FormData()
      data.append('country', country)
      data.append('bio', bio)
      data.append('fullname', fullname)
      data.append('type', type)
      if (type === "USER") {
        data.append('agencyType', 'INDIVIDUAL')
      }
      if (type === "OFFICE") {
        // if(oldType !== "OFFICE"){
        //   data.append('accountType','SIGNUP-PROCESS')
        // }
        if (licenseNumber === '') {
          l.then(() => message.success('ادخل رقم الترخيص', 2.5))
        }
        data.append('agencyType', agencyType)
        if (licenseNumber !== '' && licenseNumber !== undefined) {
          data.append('licenseNumber', licenseNumber)
        }
        if (brokerLicenseNumber !== '' && brokerLicenseNumber !== undefined) {
          data.append('brokerLicenseNumber', brokerLicenseNumber)
        }
        data.append('idNumber', idNumber)
      }
      if (type === "SUB-ADMIN") {
        data.append('permission', permission)
        data.append('workingProjects', JSON.stringify(workingProjects))
        data.append('managingProjects', JSON.stringify(managingProjects))
        data.append('workingCity', JSON.stringify(workingCity))

      }
      if (email !== '' && email !== undefined) {
        data.append('email', email)
      }
      if (password !== '' && password !== undefined) {
        data.append('password', password)
      }
      if (countryCode === "+20") {
        let thePhone = countryCode + phone
        data.append('phone', thePhone.replace('+200', '+20'))
      } else if (countryCode === "+966") {
        let thePhone = countryCode + phone
        data.append('phone', thePhone.replace('+9660', '+966'))
      } else {
        data.append('phone', countryCode + phone)
      }
      if (city != null) {
        data.append('city', city)
      }
      if (commercialFile != null && fileType) {
        for (let i = 0; i <= commercialFile.length - 1; i++) {
          data.append(`commercialFile`, commercialFile[i])
        }
      }
      if (img != null) {
        data.append('img', img)
      }

      console.log(Array.from(data))

      axios.put(`${BASE_END_POINT}user/${this.state.id}/updateInfo`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.update()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  fileChangedHandler = event => {
    this.setState({
      img: event.target.files[0],
      imgName: event.target.files[0].name,
      imgType: "data"
    })

  }
  removeFile = () => {
    this.setState({
      img: null,
      imgName: '',
      imgType: "url"
    });
  }
  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}${this.state.id}/delete`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("ROW DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  asMarketer = (enableAsMarketer) => {
    let uri = '';
    if (enableAsMarketer) {
      uri = `${BASE_END_POINT}${this.state.id}/enableAsMarketer`
    } else {
      uri = `${BASE_END_POINT}${this.state.id}/disableAsMarketer`
    }
    let l = message
      .loading('Wait..', 2.5)
    axios.put(uri, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        if (enableAsMarketer) {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ enableAsMarketer: true })
        } else {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ enableAsMarketer: false })
        }
      })
      .catch(error => {
        console.log('Error   ', error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  active = (active) => {
    let uri = '';
    if (active) {
      uri = `${BASE_END_POINT}${this.state.id}/active`
    } else {
      uri = `${BASE_END_POINT}${this.state.id}/dis-active`
    }
    let l = message
      .loading('Wait..', 2.5)
    axios.put(uri, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        if (active) {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ active: true })
        } else {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ active: false })
        }
        this.props.history.goBack()
      })
      .catch(error => {
        console.log('Error   ', error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  approved = (approved) => {
    let uri = '';
    let data = {}
    if (approved) {
      uri = `${BASE_END_POINT}${this.state.id}/approved`
    } else {
      data.reason = this.state.notApprovedReason
      uri = `${BASE_END_POINT}${this.state.id}/dis-approved`
    }
    let l = message
      .loading('Wait..', 2.5)
    axios.put(uri, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        if (approved) {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ approved: true })
        } else {
          l.then(() => message.success(allStrings.done, 2.5))
          this.setState({ approved: false })
          this.toggle2()
        }
        this.props.history.goBack()
      })
      .catch(error => {
        console.log('Error   ', error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  fileChangedHandler2 = event => {
    if (event.target.files[0]) {
      let filePreviewName = []
      filePreviewName.push(event.target.files[0].name)
      let imgs = [];
      imgs.push(event.target.files[0])
      this.setState({
        commercialFile: imgs,
        fileType: "data",
        filePreviewName: filePreviewName
      })
    }
  }
  removeFile2 = () => {
    this.setState({
      commercialFile: null,
      fileType: "url",
      filePreviewName: []
    });
  }
  submitHandlerDisApproved = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.approved(false)
  };
  changeHandlerDisApproved = (event) => {
    console.log(event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };
  toggle2 = () => {
    console.log(this.state.modal2)
    this.setState({
      modal2: !this.state.modal2,
    });
  }
  modal2 = () => (
    <MDBModal isOpen={this.state.modal2} toggle={this.toggle2} size="lg">
      <MDBModalHeader toggle={this.toggle2} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerDisApproved}
                noValidate
              >
                <div className="grey-text">
                  <MDBRow>
                    <MDBCol md="12">
                      <div className="md-form">
                        <label htmlFor="form92" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.reason}</label>
                        <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form92" className="form-control" onChange={this.changeHandlerDisApproved} required validate name="notApprovedReason" placeholder="أدخل سبب الرفض..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                      </div>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggle2}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.disApproved}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  requestsTable = () => {
    return (
      <MDBRow>
        <MDBCol md="12">
          <div className="infoTable">
            <div className="topInfoTable" style={{ backgound: 'linear-gradient(135deg, #1D9598, #127275)' }}>
              <h4>
                <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>featured_video</span> {allStrings.requests}
              </h4>
            </div>
            <div className="tableDate">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    {this.props.isRTL ?
                      <tr style={{ textAlign: 'center' }}>
                        <th>{allStrings.more}</th>
                        <th scope="col">{allStrings.status}</th>
                        <th scope="col">{allStrings.city}</th>
                        <th scope="col">{allStrings.category}</th>
                        <th scope="col">#</th>
                      </tr>
                      :
                      <tr style={{ textAlign: 'center' }}>
                        <th scope="col">#</th>
                        <th scope="col">{allStrings.category}</th>
                        <th scope="col">{allStrings.city}</th>
                        <th scope="col">{allStrings.status}</th>
                        <th>{allStrings.more}</th>
                      </tr>
                    }

                  </thead>
                  <tbody>
                    {this.state.loading ?
                      <tr style={{ height: '200px' }}>
                        <th colSpan="6" className="noData">
                          <Skeleton height={400} />
                        </th>
                      </tr>
                      :
                      this.state.requests.length > 0 ?
                        this.state.requests.map(val => (
                          this.props.isRTL ?
                            <tr style={{ textAlign: 'center' }}>
                              <td onClick={() => { this.props.history.push("requestInfo", { data: val }) }} >
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.info} placement="top">
                                    <Info style={{ color: '#33d633' }} />
                                  </Tooltip>
                                </span>
                              </td>
                              <th>{val.status === "NEW" ? allStrings.new : val.status === "COMPLETED" ? allStrings.completed : val.status === "FAILED" ? allStrings.failed : allStrings.onProgress}</th>
                              <td>{val.city.cityName}</td>
                              <th>{val.category.categoryName}</th>
                              <td>{val.id}</td>
                            </tr>
                            :
                            <tr style={{ textAlign: 'center' }}>
                              <td>{val.id}</td>
                              <th>{val.category.categoryName}</th>
                              <td>{val.city.cityName}</td>
                              <th>{val.status === "NEW" ? allStrings.new : val.status === "COMPLETED" ? allStrings.completed : val.status === "FAILED" ? allStrings.failed : allStrings.onProgress}</th>
                              <td onClick={() => { this.props.history.push("requestInfo", { data: val }) }} >
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.info} placement="top">
                                    <Info style={{ color: '#33d633' }} />
                                  </Tooltip>
                                </span>
                              </td>
                            </tr>
                        ))

                        :
                        <tr style={{ height: '200px' }}>
                          <th colSpan="6" className="noData">
                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                          </th>
                        </tr>
                    }
                  </tbody>
                </table>
                {this.state.requests.length > 0 &&
                  <div style={{ textAlign: 'center', margin: 'auto', marginTop: '3rem' }}>
                    <PaginationButtons
                      page={this.state.page}
                      pages={this.state.pages}
                      labels={allStrings}
                      onPageChange={(newPage) => {
                        this.getRequests(newPage);
                        this.setState({ page: newPage });
                      }}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    )
  }
  render() {
    return (
      <div className="App">

        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            {this.modal2()}
            {/* {this.modal3()} */}
            {this.state.actionType === "VIEW" &&
              <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                <MDBCol md='12'>
                  {this.props.currentUser.user.type === "ADMIN" &&
                    <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                      <MDBIcon icon="trash-alt" className="mr-2" />
                      {allStrings.remove}
                    </MDBBtn>
                  }
                  {this.state.accountType === "ACTIVE" ?
                    <MDBBtn
                      rounded
                      color="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                      className="btn-block z-depth-1a"
                      onClick={() => {
                        this.active(false)
                      }}
                    >
                      <MDBIcon icon="ban" className="mr-2" />
                      {allStrings.disActive}
                    </MDBBtn>
                    :
                    <MDBBtn
                      rounded
                      color="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                      className="btn-block z-depth-1a"
                      onClick={() => {
                        this.active(true)
                      }}
                    >
                      <MDBIcon icon="check-circle" className="mr-2" />
                      {allStrings.active}
                    </MDBBtn>
                  }
                  {this.state.type === "OFFICE" && !this.state.approved ?
                    <MDBBtn
                      rounded
                      ccolor="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                      className="btn-block z-depth-1a"
                      onClick={() => {
                        this.approved(true)
                      }}
                    >
                      <MDBIcon icon="check-circle" className="mr-2" />
                      {allStrings.approved}
                    </MDBBtn>
                    :
                    <MDBBtn
                      rounded
                      color="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                      className="btn-block z-depth-1a"
                      onClick={this.toggle2}
                    >
                      <MDBIcon icon="ban" className="mr-2" />
                      {allStrings.disApproved}
                    </MDBBtn>
                  }
                  {!this.state.enableAsMarketer ?
                    <MDBBtn
                      rounded
                      color="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}

                      className="btn-block z-depth-1a"
                      onClick={() => {
                        this.asMarketer(true)
                      }}
                    >
                      <MDBIcon icon="check-circle" className="mr-2" />
                      {allStrings.enableAsMarketer}
                    </MDBBtn>
                    :
                    <MDBBtn
                      rounded
                      color="none"
                      style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                      className="btn-block z-depth-1a"
                      onClick={() => {
                        this.asMarketer(false)
                      }}
                    >
                      <MDBIcon icon="ban" className="mr-2" />
                      {allStrings.disableAsMarketer}
                    </MDBBtn>
                  }
                </MDBCol>
              </MDBRow>
            }
            <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
              <MDBCol xl="12" lg="12" md="12" sm="12">

                <div className="infoCard">
                  <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>

                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>

                      {(this.state.img && this.state.actionType === "VIEW") ?
                        <div className="topIcon" style={{ padding: '0px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Image
                            width="100%"
                            height="100%"
                            style={{ objectFit: 'cover' }}
                            src={this.state.img}
                          />
                        </div>
                        :
                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                          <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>group</span>
                        </div>
                      }
                      <div className="tableTitle" style={{
                        display: 'inline-block', marginTop: '-60px',
                        marginLeft: '0', marginRight: '0'
                      }}>
                        <p>{this.state.actionType === "VIEW" ? allStrings.userProfile : allStrings.edit}</p>
                      </div>
                    </div>
                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                      <MDBContainer>
                        <MDBRow>
                          <MDBCol md="12">
                            <form
                              className="needs-validation"
                              onSubmit={this.submitHandler}
                              noValidate
                            >
                              <div className="grey-text">
                                {this.state.actionType === "VIEW" &&
                                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row' : 'row-reverse' }}>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.userType}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.user.type === "ADMIN" ? allStrings.admin : this.state.user.type === "OFFICE" ? allStrings.office : this.state.type === "SUB-ADMIN" ? allStrings.subAdmin : allStrings.client} type="text" id="form8" className="form-control" validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form8" className="form-control" validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>

                                  </MDBRow>
                                }{this.state.actionType === "VIEW" && this.state.type !== "SUB-ADMIN" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form645" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.approved}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.approved === true ? allStrings.yes : allStrings.no} type="text" id="form645" name="approved" className="form-control" onChange={this.changeHandler} validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form5" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.accountType}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.accountType === "ACTIVE" ? allStrings.active : this.state.accountType === "BLOCKED" ? allStrings.blocked : allStrings.notActive} type="text" id="form5" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.actionType === "VIEW" && this.state.type == "OFFICE" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form308" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.isVerified}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.isVerified === true ? allStrings.yes : allStrings.no} type="text" id="form308" className="form-control" validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form5" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.enableAsMarketer}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.enableAsMarketer === true ? allStrings.yes : allStrings.no} type="text" id="form5" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.actionType === "VIEW" && this.state.type === "USER" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form05" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.requestsCount}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.requestsCount} type="text" id="form05" name="requestsCount" className="form-control" onChange={this.changeHandler} validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.contactRequestCount}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.contactRequestCount} type="text" id="form005" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="md-form">
                                      <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.name}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.fullname} type="text" id="form645" name="fullname" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الاسم الكامل..." />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.email}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z0-9$@$!%*?/&#^-_. +]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.email} type="email" id="form65" name="email" className="form-control" onChange={this.changeHandler} placeholder="example@email.com" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form615" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.phone} type="text" id="form615" name="phone" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل رقم الهاتف..." />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>


                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                                    <TreeSelect virtual={false}
                                      value={this.state.country}
                                      disabled={this.state.actionType === "VIEW" ? true : false}
                                      showSearch={true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.country}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ country: value });
                                        this.getCities(value)
                                        this.getCountry(value)
                                      }}

                                    >
                                      {this.state.countries.map(val => (
                                        <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                                    <TreeSelect virtual={false}
                                      value={this.state.city ? this.state.city : []}
                                      showSearch={true}
                                      disabled={this.state.actionType === "VIEW" ? true : false}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.city}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ city: value });
                                      }}

                                    >
                                      {this.state.cities.map(val => (
                                        <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>

                                {this.state.type === "OFFICE" &&
                                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.agencyType}</label>
                                      <TreeSelect virtual={false}
                                        showSearch={true}
                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                        value={this.state.agencyType}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={false}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.agencyType}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ agencyType: value });
                                        }}

                                      >
                                        <TreeNode value="INDIVIDUAL" title={allStrings.client} key="INDIVIDUAL" />
                                        <TreeNode value="COMPANY" title={allStrings.company} key="COMPANY" />
                                        <TreeNode value="OFFICE" title={allStrings.office} key="OFFICE" />
                                        <TreeNode value="MARKETER" title={allStrings.marketer} key="MARKETER" />
                                        <TreeNode value="FREEWORK" title={allStrings.freeWork} key="FREEWORK" />

                                      </TreeSelect>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form092" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.bio}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} value={this.state.bio} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form092" className="form-control" name="bio" placeholder="أدخل النبذة التعريفية..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }{this.state.type === "OFFICE" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="formn005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.brokerLicenseNumber}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} onChange={this.changeHandler} value={this.state.brokerLicenseNumber} type="text" id="formn005" name="brokerLicenseNumber" className="form-control" placeholder="أدخل رقم رخصة الوسيط..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="formn08" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.licenseNumber}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} onChange={this.changeHandler} value={this.state.licenseNumber} type="text" id="formn08" name="licenseNumber" className="form-control" placeholder="أدخل رقم الترخيص..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.actionType === "EDIT" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form108" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.password}</label>
                                        <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form108" className="form-control" name="password" onChange={this.changeHandler} validate placeholder="أدخل كلمة المرور..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.userType}</label>
                                      <TreeSelect virtual={false}
                                        showSearch={true}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={false}
                                        value={this.state.type}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.type}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ type: value });
                                          if (value === "SUB-ADMIN") {
                                            this.getPermissions()
                                          }
                                        }}

                                      >
                                        <TreeNode value="ADMIN" title={allStrings.admin} key="ADMIN" />
                                        <TreeNode value="SUB-ADMIN" title={allStrings.employee} key="SUB-ADMIN" />
                                        <TreeNode value="USER" title={allStrings.client} key="USER" />
                                        <TreeNode value="OFFICE" title={allStrings.office} key="OFFICE" />

                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.type === "SUB-ADMIN" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.permission}</label>
                                      <TreeSelect virtual={false}
                                        value={this.state.permission ? this.state.permission : []}
                                        showSearch={true}
                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={false}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.permission}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ permission: value });
                                        }}

                                      >
                                        {this.state.permissions.map(val => (
                                          <TreeNode value={val.id} title={this.props.isRTL ? val.permission_ar : val.permission_en} key={val.id} />
                                        ))}
                                      </TreeSelect>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.workingProjects}</label>
                                      <TreeSelect virtual={false}
                                        value={this.state.workingProjects}
                                        showSearch={true}
                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={true}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.projects}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ workingProjects: value });
                                        }}

                                      >
                                        {this.state.projects.map(val => (
                                          <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                        ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.type === "SUB-ADMIN" &&
                                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.managingProjects}</label>
                                      <TreeSelect virtual={false}
                                        value={this.state.managingProjects}
                                        showSearch={true}
                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={true}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.projects}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ managingProjects: value });
                                        }}

                                      >
                                        {this.state.projects.map(val => (
                                          <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                        ))}
                                      </TreeSelect>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.workingCity}</label>
                                      <TreeSelect virtual={false}
                                        value={this.state.workingCity}
                                        showSearch={true}
                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                        treeCheckable={true}
                                        treeNodeFilterProp="title"
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        placeholder={allStrings.workingCity}
                                        onChange={(value) => {
                                          console.log(value)
                                          this.setState({ workingCity: value });
                                        }}

                                      >
                                        {this.state.cities.map(val => (
                                          <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                                        ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.type === "USER" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="formn005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.idNumber}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.idNumber} type="text" id="formn005" name="idNumber" className="form-control" />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="formn005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.nafath}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.isVerifiedIdNumber} type="text" id="formn005" name="isVerifiedIdNumber" className="form-control" />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                {this.state.type === "OFFICE" &&
                                  <MDBRow>
                                    {this.state.actionType === "EDIT" &&
                                      <MDBCol md="12">
                                        <label htmlFor="form830" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.files}</label>

                                        <div className="fileUpload2">
                                          <input mu key={this.state.commercialFile} type='file' className="upImgs2" onChange={this.fileChangedHandler2} ></input>
                                          <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.uploadFile}</span></span>
                                        </div>
                                        <div className="preview">
                                          {this.state.filePreviewName.map((val) => (
                                            <div style={{ display: "inline-block" }}>
                                              <p className="previewPdf">{val}
                                                <MDBIcon icon="times" className="mr-2 removePdf"
                                                  onClick={() => this.removeFile2()}  ></MDBIcon>
                                              </p>
                                            </div>
                                          ))}

                                        </div>
                                      </MDBCol>
                                    }
                                    {this.state.commercialFile != null &&
                                      <div>
                                        {this.state.commercialFile.map((val) => (
                                          <a href={val} target="blank" style={{
                                            background: '#1D9598',
                                            color: '#fff',
                                            padding: '4px 40px 6px',
                                            marginLeft: '15px',
                                            fontFamily: 'Cairo',
                                            fontSize: '13px'
                                          }}
                                          >
                                            {allStrings.openFile}
                                          </a>
                                        ))}
                                      </div>
                                    }


                                  </MDBRow>
                                }
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                  {this.state.actionType === "VIEW" &&
                                    <div>
                                      <Tooltip title={allStrings.calendar} placement="top">
                                        <span
                                          onClick={() => { this.props.history.push("timing", { data: { user: this.state.id, myEvents: "false" } }) }}
                                          style={{
                                            fontSize: "24px",
                                            cursor: "pointer",
                                            marginLeft: "15px",
                                            background: " #168083",
                                            borderRadius: "50%",
                                            padding: "6px 11px"
                                          }}
                                          title={allStrings.calendar}
                                        >
                                          📅
                                        </span>
                                      </Tooltip>
                                      <Tooltip title={allStrings.interests} placement="top">
                                        <span
                                          onClick={() => { this.props.history.push("interests", { data: { assignedTo: this.state.id } }) }}
                                          style={{
                                            fontSize: "24px",
                                            cursor: "pointer",
                                            marginLeft: "15px",
                                            background: " #168083",
                                            borderRadius: "50%",
                                            padding: "6px 17px",
                                            color: "#fff"
                                          }}
                                          title={allStrings.interests}
                                        >
                                          <span className="material-icons">person</span>
                                        </span>
                                      </Tooltip>
                                    </div>
                                  }
                                </div>
                                {this.state.actionType === "EDIT" &&
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <label htmlFor="form8930" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.profileImg}</label>

                                      <div className="fileUpload2">
                                        <input key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                        <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                      </div>
                                      <div className="preview">
                                        {this.state.img &&
                                          <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                            <img alt="" src={this.state.imgType === "data" ? URL.createObjectURL(this.state.img) : this.state.img} className="previewImg2" />

                                            <span className="imgName">{this.state.imgName}</span>
                                            <MDBIcon icon="trash" className="mr-2 removeImg3"
                                              onClick={() => this.removeFile()}  ></MDBIcon>
                                          </div>
                                        }
                                      </div>

                                    </MDBCol>
                                  </MDBRow>
                                }

                              </div>
                              <br></br>
                              <br></br>
                              <div className="text-center">
                                {this.state.actionType === "EDIT" &&
                                  <MDBBtn
                                    type="submit" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}
                                    rounded
                                    className="btn-block z-depth-1a"
                                  >
                                    <MDBIcon icon="edit" className="mr-2" />
                                    {allStrings.update}
                                  </MDBBtn>
                                }
                              </div>
                            </form>
                          </MDBCol>

                        </MDBRow>
                      </MDBContainer>
                    </CardContent>
                  </Card>
                </div>
              </MDBCol>
            </MDBRow>

            {this.state.type === "OFFICE" && this.state.actionType === "VIEW" &&
              this.requestsTable()
            }

          </MDBContainer>
        </Spin>
      </div>
    )
  }
}



const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(UserInfo)
);
